module.exports = __webpack_public_path__ + "static/slide-market-d1842da23004bc6143a9d24226d28f47.svg";